export const SET_USER_GROUPS = 'SET_USER_GROUPS';
export const ADD_NEW_USER_GROUP = 'ADD_NEW_USER_GROUP';
export const REPLACE_USER_GROUP = 'REPLACE_USER_GROUP';
export const SET_EXISTING_MANAGER_USERS = 'SET_EXISTING_MANAGER_USERS';
export const REMOVE_EXISTING_MANAGER_USER = 'REMOVE_EXISTING_MANAGER_USER';
